import { render, staticRenderFns } from "./UhProgressBar.vue?vue&type=template&id=f663518a&scoped=true"
import script from "./UhProgressBar.vue?vue&type=script&lang=js"
export * from "./UhProgressBar.vue?vue&type=script&lang=js"
import style0 from "./UhProgressBar.vue?vue&type=style&index=0&id=f663518a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f663518a",
  null
  
)

export default component.exports